var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"pt-2"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.iconoVisible),expression:"iconoVisible"}],staticClass:"h1 mb-0 text-center"},[_c('b-icon',{staticClass:"rounded-circle border border-dark p-2",attrs:{"icon":_vm.elIcono,"variant":"dark"}})],1),_c('h3',[_vm._v(_vm._s(_vm.titulo))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }